export function checkForUnsavedWork(state, tabKey, menuId, allowRewrite) {
    return new Promise((resolve, reject) => {
        let currentTab = state.root.tabs[tabKey];
        if (currentTab.modified &&
            (!allowRewrite || !menuId || menuId !== currentTab.menuId)) {
            window.DialogManager.LocalDialog.show({
                title: "Unsaved work",
                body: "You have unsaved work that will be lost without saving.",
                hideCloseButton: true,
                buttons: {
                    Continue: {
                        label: "Continue without saving",
                        type: "success",
                        focus: true,
                        callback: () => resolve(),
                    },
                    Cancel: {
                        label: "Cancel",
                        type: "danger",
                        focus: true,
                        keyCode: 27,
                        callback: reject,
                    },
                },
            });
        }
        else {
            resolve();
        }
    });
}
